import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface CloseInvestmentPolicyPayload {
  uuid: string;
  closedAt: string;
}

export const useCloseInvestmentPolicy = (
  options?: UseMutationOptions<any, Error, CloseInvestmentPolicyPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["closeInvestmentPolicy"],
    mutationFn: async ({ uuid, closedAt }: CloseInvestmentPolicyPayload) => {
      return axiosInstance
        .post(`/investments/${uuid}/close`, { closedAt })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Zamykanie polisy inwestycyjnej...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "close-investment-policy",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas zamykania polisy inwestycyjnej.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "close-investment-policy",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
